namespace app {
    export enum StorageMagnitude {
        Auto = 0,
        Bytes = 1,
        KB = +(1 << 3).toString(2),
        MB = +(1 << 6).toString(2),
        GB = +(1 << 9).toString(2),
        TB = +(1 << 12).toString(2),
        PB = +(1 << 15).toString(2)
    }

    export class Utilities {
        public static formatBytes(bytes: number, magnitude: StorageMagnitude = StorageMagnitude.Auto) {
            bytes = Math.ceil(bytes);

            if(bytes == 0) {
                if(magnitude == StorageMagnitude.Auto) {
                    return "0 bytes";
                } else {
                    return `0 ${StorageMagnitude[magnitude]}`;
                }
            }

            let magnitudes = _.filter(Object.keys(StorageMagnitude), key => isNaN(+key) && key !== "Auto");
            if(magnitude == StorageMagnitude.Auto) {
                let i = Math.floor(Math.log(bytes) / Math.log(1000));

                return (Math.round((bytes / Math.pow(1000, i)) * 100) / 100).toFixed(2) + ' ' + magnitudes[i];
            }
            else {
                return `${(bytes / magnitude).toFixed(2)} ${StorageMagnitude[magnitude]}`;
            }
        }

        public static isIE() {
            return new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null;
        }

        public static isInstanceOf(instance: any, type: any) {
            return instance instanceof type || instance.instance instanceof type;
        }
    }
}

// Expose as window global so bare `Utilities` references in sub-namespace files resolve
(window as any).Utilities = app.Utilities;
